import React, { useEffect, useState } from 'react';

import { ResetPasswordPresentational } from './reset-password-presentational';
import { message } from 'antd';
import { appConstant, apiUrl } from '@constants';
import Axios from 'axios';

export const ResetPasswordFunctional = ({ history, params }) => {
	const [state, setState] = useState({
		confirmPassword: null,
		newPassword: null,
		email: null,
		authKey: null,
	});

	const onFinish = (values) => {
		if (state.newPassword.trim() === state.confirmPassword.trim()) {
			const request = {
				newPassword: state.newPassword,
				authKey: state.authKey,
			};
			Axios.get(`${appConstant.domain + apiUrl.HEALTH}`)
				.then((res) => {
					Axios.put(`${appConstant.domain}${apiUrl.RESET_FORGOT_PASSWORD}`, request)
						.then((res) => {
							if (res.data.success) {
								message.success('Password Reset successfully..');
								history.push('/login');
							} else {
								message.error(res.data.messages && res.data.messages[0]);
							}
						})
						.catch((err) => {
							if (err.response) {
								message.error(err.response.data.messages && err.response.data.messages[0]);
							}
						});
				})
				.catch((err) => {});
		} else {
			message.error(`Password and Confrim Password doesn't Match \n Try Again`);
		}
	};

	const componentDidMount = () => {
		if (params.id) {
			setState({
				...state,
				authKey: params.id,
			});
		} else {
			history.push('/login');
		}
	};
	useEffect(() => {
		componentDidMount();
	}, []);
	return <ResetPasswordPresentational history={history} state={state} setState={setState} onFinish={onFinish} />;
};
